import { BoxDto } from '../models/dtos/BoxDto';
import { BoxData } from '../models/Box';

/**
 * Mapea BoxDto (tal cual viene de la API en data.data) a BoxData
 */
export const mapBoxDtoToBoxData = (dto: BoxDto): BoxData => ({
  id: dto.id,
  name: dto.name,
  logo: dto.logo,
  address: dto.address,
  zip_code: dto.zip_code,
  phone_number: dto.phone_number,
  facebook_account: dto.facebook_account,
  twitter_account: dto.twitter_account,
  instagram_account: dto.instagram_account,
  privacy_policy: dto.privacy_policy,
  rules: dto.rules,
  normative: dto.normative,
  logo_login: dto.logo_login,
  logo_loading: dto.logo_loading,
  logo_contact: dto.logo_contact,
  ranking_background: dto.ranking_background,
  wods_background: dto.wods_background,
  reservations_background: dto.reservations_background,
  blocks_background: dto.blocks_background,
  admin_email: dto.admin_email,
  support_email: dto.support_email,
  no_reply_email: dto.no_reply_email,
  info_email: dto.info_email,
  sender_name: dto.sender_name,
  stripe_pk: dto.stripe_pk,
  pair_box: dto.pair_box,
  stripe_callback_token: dto.stripe_callback_token,
  sync_rating_types: dto.sync_rating_types,
  sync_exercises: dto.sync_exercises,
  sync_wods: dto.sync_wods,
  online_payment: dto.online_payment,
  default_fee_id: dto.default_fee_id,
  reserve_until: dto.reserve_until,
  reserve_advanced: dto.reserve_advanced,
  min_athletes_per_class: dto.min_athletes_per_class,
  administration_fees: dto.administration_fees,
  payment_reminder_day: dto.payment_reminder_day,
  automatically_disable_day: dto.automatically_disable_day,
  time_to_start_reservation: dto.time_to_start_reservation,
  logoLoginUrl: dto.logoLoginUrl,
  logoLoadingUrl: dto.logoLoadingUrl,
  logoContactUrl: dto.logoContactUrl,
  rankingBackgroundUrl: dto.rankingBackgroundUrl,
  wodsBackgroundUrl: dto.wodsBackgroundUrl,
  reservationsBackgroundUrl: dto.reservationsBackgroundUrl,
  blocksBackgroundUrl: dto.blocksBackgroundUrl,
  is_open: dto.is_open,
});
